var App = App || {};

App.FancyboxGallery = (function() {
  'use strict';

  var initialize = function() {
    _initFancybox();
  };

  var _initFancybox = function() {
     $('.js-gallery-lightbox').fancybox({
        closeBtn: true
    });
  };

  return {
    initialize: initialize
  };
}());